import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './polyfills';
import './config/deployment'; // Initialize deployment target
import App from './App.tsx';
import { AuthCallback } from './pages/AuthCallback.tsx';
import './index.css';
import { logger } from '@inboundx/shared/platform';

type PreprodWindow = Window & {
    __INBOUNDX_POSTHOG_KEY__?: string;
    __INBOUNDX_POSTHOG_HOST__?: string;
};

// PostHog configuration - expose on window for analytics system (same pattern as widget)
// This must happen before React renders to ensure PostHog is available when components mount
if (typeof window !== 'undefined') {
    const POSTHOG_KEY =
        typeof __INBOUNDX_POSTHOG_KEY__ !== 'undefined' ? __INBOUNDX_POSTHOG_KEY__ : undefined;
    const POSTHOG_HOST =
        typeof __INBOUNDX_POSTHOG_HOST__ !== 'undefined' ? __INBOUNDX_POSTHOG_HOST__ : undefined;

    const preprodWindow = window as PreprodWindow;
    preprodWindow.__INBOUNDX_POSTHOG_KEY__ = POSTHOG_KEY;
    preprodWindow.__INBOUNDX_POSTHOG_HOST__ = POSTHOG_HOST;

    logger.info('PreProd: PostHog config set', { hasKey: !!POSTHOG_KEY, host: POSTHOG_HOST });
}

// Note: StrictMode is disabled for playground to avoid double initialization warnings
// in development. This matches the widget pattern where StrictMode is not used.
// The analytics system has guards against double initialization, but StrictMode
// intentionally double-mounts components which triggers the warning.
const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element not found');
}

createRoot(rootElement).render(
    <BrowserRouter>
        <Routes>
            <Route path="/*" element={<App />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
        </Routes>
    </BrowserRouter>
);
